<template>
  <div-box>
    <wallet-head show_type="2" />
    <div-height height="5vw"></div-height>
    <div class="lever_box">
      <div class="lever_item">
        <img src="@/assets/img/lever00.png" v-if="!info.level_id" />
        <img src="@/assets/img/lever01.png" v-if="info.level_id == 1" />
        <img src="@/assets/img/lever02.png" v-if="info.level_id == 2" />
        <img src="@/assets/img/lever03.png" v-if="info.level_id == 3" />
        <img src="@/assets/img/lever04.png" v-if="info.level_id == 4" />
        <img src="@/assets/img/lever05.png" v-if="info.level_id == 5" />
        <img src="@/assets/img/lever06.png" v-if="info.level_id == 6" />
        <img src="@/assets/img/lever07.png" v-if="info.level_id == 7" />
        <img src="@/assets/img/lever08.png" v-if="info.level_id == 8" />
        <img src="@/assets/img/lever09.png" v-if="info.level_id == 9" />
      </div>


    </div>

    <div-height height="3vw"></div-height>

    <div-flex center>
      <div-text color='#fff' size='4vw' bold v-if="info.level_id">
        {{ $t('会员等级') }}：{{ info.level.level_name }}
      </div-text>
      <div-text color='#fff' size='4vw' bold v-else>
        {{ $t('会员等级') }}：V0
      </div-text>
    </div-flex>


    <div-height height="5vw"></div-height>

    <div class="add_box">
      <div-height height="3vw"></div-height>

      <div class="label"> {{ $t('我的钱包地址') }}：{{ formatAddress(info.account) }}</div>

      <div class="label" v-if="info.parent">{{ $t('上级钱包地址') }}：{{ formatAddress(info.parent.account) }}</div>

      <div-height height="3vw"></div-height>

      <div class="link_box">
        <div class="link_item" @click="router('qianbao01_list')">
          <div class="link_text" style="color:#00ffb5">USDT{{ $t('资产') }} <van-icon name="arrow"
              style="margin-left: 1.5vw;" />
          </div>
          <div-height height="3vw"></div-height>
          <div class="link_text" style="font-size: 4vw;font-weight: bold;">{{ balance }}</div>
        </div>
        <div class="link_item" @click="router('qianbao02_list')">
          <div class="link_text" style="color:#00ffb5">
            {{ $t('累计收益') }} <van-icon name="arrow" style="margin-left: 1.5vw;" /></div>
          <div-height height="3vw"></div-height>
          <div class="link_text" style="font-size: 4vw;font-weight: bold;">{{ total_income }}</div>
        </div>
      </div>

      <div-height height="3vw"></div-height>
      <div class="add_box_btn" style="width: 60vw; margin: 0 auto;">
        <van-button size="small" round block color="rgba(32, 197, 149, 1)" @click="router('tixian02')">
          {{ $t('提现') }}
        </van-button>
      </div>
    </div>

    <div-height height="5vw"></div-height>

    <div class="add_box">
      <div-height height="5vw"></div-height>

      <div class="tu_box">
        <div class="img">
          <img src="@/assets/img/logo.png" />
        </div>

        <div class="link_item">
          <div-height height="3vw"></div-height>
          <div class="link_text" style="color:#00ffb5" @click="router('qianbao03_list')">
            DAB{{ $t('资产') }}：{{ dab }} <van-icon name="arrow" style="margin-left: 1.5vw;" />
          </div>
          <div-height height="5vw"></div-height>
          <div class="add_box_btn">
            <van-button size="small" round block color="rgba(32, 197, 149, 1)" @click="router('tixian01')">
              {{ $t('提现') }}
            </van-button>
          </div>
        </div>

      </div>

      <div-height height="5vw"></div-height>

      <div class="link_box">
        <div class="link_item">
          <div class="link_text"> {{ $t('我的算力') }} </div>
          <div-height height="3vw"></div-height>
          <div class="link_text" style="font-size: 4vw;font-weight: bold;">{{ power }}</div>
        </div>
        <div class="link_item">
          <div class="link_text">{{ $t('全网总算力') }} </div>
          <div-height height="3vw"></div-height>
          <div class="link_text" style="font-size: 4vw;font-weight: bold;">{{ total_power }}</div>
        </div>
      </div>


    </div>


  </div-box>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      balance: '0.00',
      total_income: '0.00',
      dab: '0.00',
      power: '0.00',
      total_power: '0.00',

    }
  },
  created() {
    this.get_info()
    this.get_data()
  },
  methods: {
    get_data() {
      this.$get({
        url: "/api/v1/member/getStatistics",
        success: (res) => {

          this.balance = res.data.balance * 1;

          this.total_income = res.data.total_income * 1;
          this.dab = res.data.dab * 1;
          this.power = res.data.power * 1;
          this.total_power = res.data.total_power * 1;
        },
        fail: () => { },
      });
    },
    get_info() {
      this.$get({
        url: "/api/v1/member/getMemberInfo",
        success: (res) => {
          this.info = res.data || {};
        },
        fail: () => { },
      });
    },
    // 工具：格式化地址
    formatAddress(addr) {
      if (!addr) return "";
      return addr.length > 10
        ? addr.substring(0, 6) + "..." + addr.substring(addr.length - 4)
        : addr;
    },
  },
}
</script>
<style lang='less' scoped>
.lever_box {
  display: flex;
  align-items: center;
  justify-content: center;

  .lever_item {
    width: 24vw;
    height: 24vw;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}

.add_box {
  width: 90vw;
  height: 69vw;
  border-radius: 3vw;
  background: url("~@/assets/img/kuang.png") no-repeat;
  margin: 0 auto;
  background-size: 100%;
  background-position: center;
  padding: 7vw 6vw;

  .label {
    font-size: 4vw;
    color: #fff;
    padding: 1vw 0;
    text-align: center;
  }

  .border {
    display: flex;
    font-size: 4vw;
    color: #fff;
    padding: 1.5vw;
    border: 1px solid #20c595;
    border-radius: 2vw;
    justify-content: space-between;

    .icon {
      font-size: 10vw;
      height: 4vw;
      line-height: 4vw;
    }
  }
}

.link_box {
  display: flex;
  justify-content: space-between;

  .link_item {
    width: 45vw;
  }
}

.tu_box {
  display: flex;
  justify-content: space-between;

  .img {
    width: 25vw;
    height: 25vw;
    transform: rotate(-10deg);

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

  }
}

.link_text {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>